var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Leader = function Leader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7Zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M10 16a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5h1a1 1 0 1 1 0 2h-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.67 14.665a.75.75 0 0 0-1.34 0l-.83 1.658-1.623.27a.75.75 0 0 0-.407 1.27l1.068 1.069-.28 1.962a.75.75 0 0 0 1.077.777L15 20.839l1.665.832a.75.75 0 0 0 1.078-.777l-.28-1.962 1.067-1.068a.75.75 0 0 0-.407-1.27l-1.623-.271-.83-1.658Zm-1 2.67.33-.658.33.658a.75.75 0 0 0 .547.405l.562.094-.303.302a.75.75 0 0 0-.212.637l.131.916-.72-.36a.75.75 0 0 0-.67 0l-.72.36.13-.916a.75.75 0 0 0-.211-.637l-.303-.302.562-.094a.75.75 0 0 0 .548-.405Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Leader;